/**
 * @generated SignedSource<<1e57bb3185e9f66bf1fb7e21d0833570>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PlayerType = "CUSTOMER" | "GUEST" | "MEMBER";
export type TransportationCode = "CADDIE" | "CADDIE_CART" | "CART" | "FULL_CART" | "MOTOR_PULL_CART" | "PRIVATE_CART" | "PULL_CART" | "SINGLE_CART" | "WALK";
export type useSetValidTransportationTypeQuery$variables = {
  memberId?: string | null | undefined;
  playerType?: PlayerType | null | undefined;
  slotId: string;
};
export type useSetValidTransportationTypeQuery$data = {
  readonly node: {
    readonly id?: string;
    readonly preferredTransportationType?: {
      readonly code: TransportationCode | null | undefined;
      readonly enabled: boolean;
      readonly id: string;
    } | null | undefined;
    readonly transportationTypes?: ReadonlyArray<{
      readonly code: TransportationCode | null | undefined;
      readonly customCode: string | null | undefined;
      readonly eighteenHolePrice: number | null | undefined;
      readonly enabled: boolean;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly nineHolePrice: number | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useSetValidTransportationTypeQuery = {
  response: useSetValidTransportationTypeQuery$data;
  variables: useSetValidTransportationTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "playerType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "slotId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "memberId",
    "variableName": "memberId"
  },
  {
    "kind": "Literal",
    "name": "memberVisible",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "playerType",
    "variableName": "playerType"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "TransportationType",
  "kind": "LinkedField",
  "name": "transportationTypes",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v7/*: any*/),
    {
      "alias": "nineHolePrice",
      "args": [
        {
          "kind": "Literal",
          "name": "holeCount",
          "value": "NINE"
        }
      ],
      "kind": "ScalarField",
      "name": "totalPrice",
      "storageKey": "totalPrice(holeCount:\"NINE\")"
    },
    {
      "alias": "eighteenHolePrice",
      "args": [
        {
          "kind": "Literal",
          "name": "holeCount",
          "value": "EIGHTEEN"
        }
      ],
      "kind": "ScalarField",
      "name": "totalPrice",
      "storageKey": "totalPrice(holeCount:\"EIGHTEEN\")"
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "TransportationType",
  "kind": "LinkedField",
  "name": "preferredTransportationType",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetValidTransportationTypeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "type": "Slot",
            "abstractKey": "__isSlot"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSetValidTransportationTypeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "type": "Slot",
            "abstractKey": "__isSlot"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e1ad91ee936b3e2a763723ccf268bfe0",
    "id": null,
    "metadata": {},
    "name": "useSetValidTransportationTypeQuery",
    "operationKind": "query",
    "text": "query useSetValidTransportationTypeQuery(\n  $slotId: ID!\n  $memberId: ID\n  $playerType: PlayerType\n) {\n  node(id: $slotId) {\n    __typename\n    ... on Slot {\n      __isSlot: __typename\n      id\n      transportationTypes(memberId: $memberId, memberVisible: true, playerType: $playerType) {\n        id\n        code\n        customCode\n        name\n        enabled\n        nineHolePrice: totalPrice(holeCount: NINE)\n        eighteenHolePrice: totalPrice(holeCount: EIGHTEEN)\n      }\n      preferredTransportationType(memberId: $memberId, memberVisible: true, playerType: $playerType) {\n        id\n        code\n        enabled\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5f800a343f3f20e29f036a5f45262b64";

export default node;
